import SaveAndNavigate from "../../Components/SaveAndNavigate";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import React, { useContext, useEffect, useState } from "react";
import {
  SideMenuItems,
  ToastMessageType,
  HTTPResponse,
  ToastMessages,
  PageDesignConstants,
} from "../../Helpers/Enums";
import ErrorField from "../../Components/ErrorField";
import {
  CommonError_Msgs,
  EligibilityCriteria_Msgs,
  hyperlinkTextAEReporting,
} from "../../Helpers/HelperText";
import { AppContext } from "../../Contexts/AppContextProvider";
import {
  AddLocalStorageData,
  GetLocalStorageData,
  GetLoggedInUserID,
} from "../../Helpers/Utilities";
import { EligibilityCriteriaService } from "../../WebApiServices/EligibilityCriteria.service";
import InfoPopUp from "../../Components/InfoPopUp";

const TransitionToChartAbstraction = () => {
  const [showEligibleMatchTarget, setShowEligibleMatchTarget] = useState(false);
  const [cohortTreatment, setCohortTreatment] = useState("");
  const [showEligibleSingleTarget, setShowEligibleSingleTarget] =
    useState(false);
  const [showEligibleTarget, setShowEligibleTarget] = useState(false);

  const [selectedCohortTreatmentID, setSelectedCohortTreatmentID] =
    useState(null);
  const [cohortTreatmentS16, setCohortTreatmentS16] = useState([]);
  const [originalS16, setOriginalS16] = useState([]);
  const [cohortTreatmentS15, setCohortTreatmentS15] = useState([]);
  const [isEligible, setIsEligible] = useState(false);
  const [isAllDataFilled, setIsAllDataFilled] = useState(false);
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);
  const [
    showHideHyperlinkModalAEReporting,
    setShowHideHyperlinkModalAEReporting,
  ] = useState(false);
  const [eligibilityDisabled, setEligibilityDisabled] = useState(false);

  const pid = GetLocalStorageData("patientId") ?? 0;
  let patientData = GetLocalStorageData("patient");
  patientData = patientData && JSON.parse(patientData);
  const eligibilityCriteriaLocked =
    patientData?.eligibilityCriteriaLocked ?? false;

  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    ShowActionPopUp,
    setIsSideMenuActive,
    patientConfigData,
  } = useContext(AppContext);

  const navigatePaths = {
    //Additional Exclusion Criteria is skipped entirely when it has nothing to ask, so
    //Previous has to go back past it to the page that actually precedes this one.
    prevPage:
      patientConfigData?.data?.showExclusionCriteriaPage === false
        ? patientConfigData?.data?.showEligibilityPages
          ? "/RRMMComboTherapy"
          : "/RRMMCriteria"
        : "/ExclusionCriteria",
    currPage: "/TransitionToChartAbstraction",
    nextPage: eligibilityCriteriaLocked
      ? isEligible
        ? "/Demographics"
        : "/ManagePatients"
      : isAllDataFilled && isEligible
        ? "/Demographics"
        : isAllDataFilled && !isEligible
          ? "/ManagePatients"
          : "/TransitionToChartAbstraction",
  };

  const centerId = patientData?.ptCenterId ?? 0;

  ////Cohort treatment
  const cohortTreatmentModelList = [];

  //ChartSelection
  const chartSelection = GetLocalStorageData("ChartSelection");

  let chartSelectionList = chartSelection ? JSON.parse(chartSelection) : [];

  const RepeaterRow = {
    PatientEligibilityId: 0,
    s15cohortTreatment: null,
    s16NoCohortTreatment: null,
    metInclusionCriteria: null,
    eligibilityChartUpdates: 0,
    s15Empty: false,
    s16Empty: false,
    unmatchedOneTreatmentId: 0,
    matchedCohortId: 0,
    s16CohortTreatmentAdditionalPriority: [
      {
        patientCohortTreatmentAdditionalPriorityId: 0,
        s16additionCohort: false,
        cohortTreatmentID: 0,
        cohortTreatmentName: "",
        isEligible: true,
        cohortTreatmentNameSuperscript: "",
      },
    ],

    cohortTreatmentMatchedTargets: [
      {
        patientCohortTreatmentMatchedTargetId: 0,
        cohortTreatmentID: 0,
        cohortTreatmentName: "",
        isEligible: false,
        cohortTreatmentNameSuperscript: "",
      },
    ],
  };

  const [additionalPriority, setAdditionalPriority] = useState([RepeaterRow]);

  useEffect(() => {
    async function FetchData() {
      if (!isNaN(pid) && Number(pid) !== 0) {
        ToggleLoader(true);
        await LoadData();
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  async function LoadData() {
    try {
      const response =
        await EligibilityCriteriaService.LoadAdditionalCohortTreatment(pid); //,pid
      if (response?.status === HTTPResponse.OK) {
        const { data } = response;

        setIsEligible(data.metInclusionCriteria); //12108 fix
        setEligibilityDisabled(data.eligibilityLocked);
        setAdditionalPriority((prev) => ({
          ...prev,
          s15Empty: false,
          s16Empty: false,
          metInclusionCriteria: data.metInclusionCriteria,
          PatientEligibilityId: data.patientEligibilityId,
        }));

        data.cohortTreatmentModelList.forEach((item) => {
          cohortTreatmentModelList.push(item);
        });
        setCohortTreatmentS15(
          cohortTreatmentModelList.filter((item) => item.isEligible === true),
        );
        let ineligibleArray = [];
        let eligibleArray = [];
        let matchingcount = 0,
          unmatchedcount = 0;

        if (data.metInclusionCriteria == true) {
          if (
            data.unmatchedOneTreatmentId != null &&
            data.unmatchedOneTreatmentId != 0
          ) {
            const matchingItem = cohortTreatmentModelList.find(
              (item) => item.cohortTreatmentID === data.unmatchedOneTreatmentId,
            );
            if (matchingItem) {
              matchingItem.cohortTreatmentName =
                matchingItem.cohortTreatmentName === "DKRd (TE or TIE)"
                  ? matchingItem.cohortTreatmentSCT === 1
                    ? "DKRd (TE)"
                    : matchingItem.cohortTreatmentSCT === 2
                      ? "DKRd (TIE)"
                      : matchingItem.cohortTreatmentName
                  : matchingItem.cohortTreatmentName;
              eligibleArray.push(matchingItem);
              unmatchedcount = 1;
            }
          } else if (
            (data.unmatchedonecohorttreatmentid == null ||
              data.unmatchedonecohorttreatmentid == 0 ||
              data.unmatchedonecohorttreatmentid == undefined) &&
            (data.cohortTreatmentPriorityID == null ||
              data.cohortTreatmentPriorityID == 0) &&
            data.cohortTreatmentAdditionalPriorityList.length > 0
          ) {
            if (
              cohortTreatmentModelList.length > 0 &&
              chartSelectionList.length > 0
            ) {
              cohortTreatmentModelList.forEach((item) => {
                item.cohortTreatmentName =
                  item.cohortTreatmentName === "DKRd (TE or TIE)"
                    ? item.cohortTreatmentSCT === 1
                      ? "DKRd (TE)"
                      : item.cohortTreatmentSCT === 2
                        ? "DKRd (TIE)"
                        : item.cohortTreatmentName
                    : item.cohortTreatmentName;

                if (item.isEligible != false) {
                  const matchingItem = chartSelectionList.find(
                    (item2) =>
                      item2.cohortTreatmentID === item.cohortTreatmentID,
                  );
                  let newCharts = matchingItem.newCharts ?? 0;
                  if (newCharts != null) {
                    let updates = matchingItem.eligibilityChartUpdates ?? 0;

                    if (updates == newCharts) {
                      matchingcount = matchingcount + 1;
                      ineligibleArray.push(item);
                    } else {
                      unmatchedcount = unmatchedcount + 1;
                      eligibleArray.push(item);
                    }

                    item.isEligible = updates == newCharts ? false : true;
                  }
                } else {
                  matchingcount = matchingcount + 1;
                  ineligibleArray.push(item);
                }
              });

              if (data.cohortTreatmentModelList.length > 0)
                AddLocalStorageData(
                  "CohortTreatment",
                  JSON.stringify(cohortTreatmentModelList),
                );
              else AddLocalStorageData("CohortTreatment", JSON.stringify([]));
              // AddLocalStorageData("ChartSelection", JSON.stringify(data.roundModels[0].centerTreatmentRoundList))
            }
          } else if (
            (data.cohortTreatmentPriorityID != null ||
              data.cohortTreatmentPriorityID != 0) &&
            (data.noAdditionalCohortTreatmentPriorities == null ||
              data.noAdditionalCohortTreatmentPriorities == true ||
              data.noAdditionalCohortTreatmentPriorities == false)
          ) {
            unmatchedcount = 2;
          }
        } else if (data.metInclusionCriteria == false) {
          if (data.cohortTreatmentMatchedTargetList.length > 0) {
            for (
              let j = 0;
              j < data.cohortTreatmentMatchedTargetList.length;
              j++
            ) {
              let childData = data.cohortTreatmentMatchedTargetList[j];
              const matchingItem = cohortTreatmentModelList.find(
                (item) =>
                  item.cohortTreatmentID === childData.cohortTreatmentId,
              );
              if (matchingItem) {
                matchingItem.cohortTreatmentName =
                  matchingItem.cohortTreatmentName === "DKRd (TE or TIE)"
                    ? matchingItem.cohortTreatmentSCT === 1
                      ? "DKRd (TE)"
                      : matchingItem.cohortTreatmentSCT === 2
                        ? "DKRd (TIE)"
                        : matchingItem.cohortTreatmentName
                    : matchingItem.cohortTreatmentName;
                ineligibleArray.push(matchingItem);
                matchingcount = 2;
              }
            }
          }
        }

        if (matchingcount > 0 && unmatchedcount == 0) {
          const formattedString = ineligibleArray
            .map((part) => {
              let formattedName = part.cohortTreatmentName;

              if (part.cohortTreatmentNameSuperscript) {
                const superscript = part.cohortTreatmentNameSuperscript.slice(
                  0,
                  2,
                );
                const remainingText =
                  part.cohortTreatmentNameSuperscript.slice(2);
                formattedName += `<sup class="superscript">${superscript}</sup>${remainingText}`;
              }

              return formattedName;
            })
            .join(", ");
          setCohortTreatment(formattedString);
          setShowEligibleMatchTarget(true);
          let dataarray = [];
          let datacomponent = {
            PatientEligibilityId: data.patientEligibilityId,
            s15cohortTreatment: data.cohortTreatmentPriorityID,
            s16NoCohortTreatment:
              data.noAdditionalCohortTreatmentPriorities == true
                ? 1
                : (0 ?? null),
            s16CohortTreatmentAdditionalPriority: [],
            metInclusionCriteria: false, //data.metInclusionCriteria,
            cohortTreatmentMatchedTargets: [],
            s16Empty: false,
            s15Empty: false,
          };

          for (let j = 0; j < ineligibleArray.length; j++) {
            let childData = ineligibleArray[j];
            const matchingItem = data.cohortTreatmentMatchedTargetList.find(
              (item) => item.cohortTreatmentId === childData.cohortTreatmentID,
            );

            if (matchingItem) {
              let datasubcomponent = {
                patientCohortTreatmentMatchedTargetId:
                  matchingItem.patientCohortTreatmentMatchedTargetId != null
                    ? matchingItem.patientCohortTreatmentMatchedTargetId
                    : 0,
                cohortTreatmentID:
                  matchingItem.cohortTreatmentId != null
                    ? matchingItem.cohortTreatmentId
                    : 0,
              };
              dataarray.push(datasubcomponent);
            }
          }

          datacomponent.cohortTreatmentMatchedTargets.push(dataarray);
          setAdditionalPriority(datacomponent);
        } else if (unmatchedcount == 1) {
          const formattedString = eligibleArray
            .map((part) => {
              let formattedName = part.cohortTreatmentName;

              if (part.cohortTreatmentNameSuperscript) {
                const superscript = part.cohortTreatmentNameSuperscript.slice(
                  0,
                  2,
                );
                const remainingText =
                  part.cohortTreatmentNameSuperscript.slice(2);
                formattedName += `<sup class="superscript">${superscript}</sup>${remainingText}`;
              }

              return formattedName;
            })
            .join(", ");

          setCohortTreatment(formattedString);
          setShowEligibleSingleTarget(true);

          setAdditionalPriority((prev) => ({
            ...prev,
            unmatchedOneTreatmentId: eligibleArray[0].cohortTreatmentID,
            cohortTreatmentMatchedTargets: [],
          }));
        } else if (unmatchedcount > 1) {
          setShowEligibleTarget(true);
          let dataarray = [];
          let datacomponent = {
            PatientEligibilityId: data.patientEligibilityId,
            s15cohortTreatment: data.cohortTreatmentPriorityID,
            s16NoCohortTreatment:
              data.noAdditionalCohortTreatmentPriorities == true
                ? 1
                : (0 ?? null),
            s16CohortTreatmentAdditionalPriority: [],
            metInclusionCriteria: data.metInclusionCriteria,
            cohortTreatmentMatchedTargets: [],
            s16Empty: false,
            s15Empty: false,
          };

          var eligibleCohortTreatmentAdditionalPriorityList =
            data.cohortTreatmentAdditionalPriorityList?.filter(
              (item) => item.isEligible === true,
            );
          if (eligibleCohortTreatmentAdditionalPriorityList?.length > 0) {
            for (
              let j = 0;
              j < eligibleCohortTreatmentAdditionalPriorityList.length;
              j++
            ) {
              let childData = eligibleCohortTreatmentAdditionalPriorityList[j];
              let datasubcomponent = {
                s16additionCohort:
                  childData.additionalCohortTreatmentId != null
                    ? childData.additionalCohortTreatmentId
                    : datacomponent.s16NoCohortTreatment !== 1, //auto-select by default, unless "No additional treatment cohorts" was chosen
                patientCohortTreatmentAdditionalPriorityId:
                  childData.patientCohortTreatmentAdditionalPriorityId != null
                    ? childData.patientCohortTreatmentAdditionalPriorityId
                    : 0,
                cohortTreatmentID:
                  childData.cohortTreatmentId != null
                    ? childData.cohortTreatmentId
                    : 0,
                cohortTreatmentName:
                  childData.cohortTreatmentName != null
                    ? childData.cohortTreatmentName
                    : 0,
                isEligible:
                  childData.isEligible != null ? childData.isEligible : false,
                cohortTreatmentNameSuperscript:
                  childData != null
                    ? childData.cohortTreatmentNameSuperscript
                    : "",
              };
              dataarray.push(datasubcomponent);
            }
          }

          datacomponent.s16CohortTreatmentAdditionalPriority.push(dataarray);
          setAdditionalPriority(datacomponent);
          const updatedList =
            datacomponent.s16CohortTreatmentAdditionalPriority[0].filter(
              (item) =>
                item.cohortTreatmentID !== data.cohortTreatmentPriorityID,
            );
          setSelectedCohortTreatmentID(data.cohortTreatmentPriorityID);
          setCohortTreatmentS16(updatedList);
          setOriginalS16(updatedList);

          const formattedString = updatedList
            .filter((part) => {
              return part.s16additionCohort === true;
            })
            .map((part) => {
              let formattedName = part.cohortTreatmentName;

              if (part.cohortTreatmentNameSuperscript) {
                const superscript = part.cohortTreatmentNameSuperscript.slice(
                  0,
                  2,
                );
                const remainingText =
                  part.cohortTreatmentNameSuperscript.slice(2);
                formattedName += `<sup class="superscript">${superscript}</sup>${remainingText}`;
              }

              return formattedName;
            })
            .join(", ");

          if (
            cohortTreatmentModelList?.length > 0 &&
            data.cohortTreatmentPriorityID
          ) {
            const filteredTmtList = cohortTreatmentModelList.filter(
              (item) =>
                item.cohortTreatmentID === data.cohortTreatmentPriorityID,
            );
            let treatmentNames = "";
            if (filteredTmtList?.length > 0) {
              treatmentNames =
                formattedString === ""
                  ? ""
                  : filteredTmtList[0].cohortTreatmentName +
                    ", " +
                    formattedString;
            } else {
              treatmentNames = "";
            }
            setCohortTreatment(treatmentNames);
          }
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  }

  const BuildFormattedString = (list) =>
    list
      .filter((p) => p.s16additionCohort)
      .map((part) => {
        let name = part.cohortTreatmentName;
        if (part.cohortTreatmentNameSuperscript) {
          const sup = part.cohortTreatmentNameSuperscript.slice(0, 2);
          const rest = part.cohortTreatmentNameSuperscript.slice(2);
          name += `<sup class="superscript">${sup}</sup>${rest}`;
        }
        return name;
      })
      .join(", ");

  const SyncCohortTreatmentStorage = (updatedList) => {
    const stored = GetLocalStorageData("CohortTreatment");
    const cohortTreatment =
      stored && stored !== "null" ? JSON.parse(stored) : [];
    const selectedS15Id = additionalPriority.s15cohortTreatment;
    const lookup = new Map(
      updatedList.map((x) => [x.cohortTreatmentID, x.s16additionCohort]),
    );
    const updatedStorage = cohortTreatment.map((item) => {
      if (item.cohortTreatmentID === selectedS15Id) {
        return {
          ...item,
          isEligible: true,
        };
      }

      if (lookup.has(item.cohortTreatmentID)) {
        return {
          ...item,
          isEligible: lookup.get(item.cohortTreatmentID),
        };
      }

      return item;
    });
    AddLocalStorageData("CohortTreatment", JSON.stringify(updatedStorage));
  };

  const HandleChange = (event) => {
    const id = parseInt(event.target.value);

    setSelectedCohortTreatmentID(id);

    const updatedList = originalS16.filter(
      (item) => item.cohortTreatmentID !== id,
    );

    setCohortTreatmentS16(updatedList);

    SyncCohortTreatmentStorage(updatedList);

    setAdditionalPriority((prev) => ({
      ...prev,
      s15cohortTreatment: id,
      s15Empty: false,
    }));

    const treatmentName = cohortTreatmentS15.find(
      (item) => item.cohortTreatmentID === id,
    );
    if (!treatmentName) return;

    const baseName = treatmentName.cohortTreatmentName;
    const formattedString = BuildFormattedString(updatedList);
    setCohortTreatment(
      formattedString ? `${baseName}, ${formattedString}` : baseName,
    );
  };

  const HandleCheckboxChange = (event) => {
    const id = Number(event.target.value);

    const updatedOriginal = originalS16.map((item) =>
      item.cohortTreatmentID === id
        ? {
            ...item,
            s16additionCohort: !item.s16additionCohort,
          }
        : item,
    );

    setOriginalS16(updatedOriginal);

    setCohortTreatmentS16(
      updatedOriginal.filter(
        (item) => item.cohortTreatmentID !== selectedCohortTreatmentID,
      ),
    );

    SyncCohortTreatmentStorage(updatedOriginal);

    setAdditionalPriority((prev) => ({
      ...prev,
      s16NoCohortTreatment: null,
      s16Empty: false,
    }));

    const selectedS15 = cohortTreatmentS15.find(
      (item) =>
        item.cohortTreatmentID === additionalPriority.s15cohortTreatment,
    );

    const baseName = selectedS15?.cohortTreatmentName ?? "";
    const formattedString = BuildFormattedString(updatedOriginal);

    setCohortTreatment(
      baseName && formattedString
        ? `${baseName}, ${formattedString}`
        : baseName || formattedString || "",
    );
  };

  const HandleChangeNoTreatment = (event) => {
    const { name, value } = event.target;
    const value_int = Number(value);

    if (value_int !== 1) return;

    setAdditionalPriority((prev) => ({
      ...prev,
      [name]: value_int,
      s16Empty: false,
    }));

    const updatedMaster = originalS16.map((item) => ({
      ...item,
      s16additionCohort: false,
    }));

    setOriginalS16(updatedMaster);

    setCohortTreatmentS16(
      updatedMaster.filter(
        (item) => item.cohortTreatmentID !== selectedCohortTreatmentID,
      ),
    );

    SyncCohortTreatmentStorage(updatedMaster);

    const selectedS15 = cohortTreatmentS15.find(
      (item) =>
        item.cohortTreatmentID === additionalPriority.s15cohortTreatment,
    );
    setCohortTreatment(selectedS15?.cohortTreatmentName ?? "");
  };

  const SavePage = async () => {
    let callSaveMethod = false;

    if (!eligibilityDisabled && showEligibleMatchTarget === false) {
      const choice = await ShowActionPopUp(
        "Alert", //title
        <div>{renderStyledMessage()}</div>, //message
        "OK", //Confirm button text
        false,
      );
      if (!choice) {
        return;
      } else {
        callSaveMethod = true;
      }
    } else {
      callSaveMethod = true;
    }

    if (callSaveMethod) {
      try {
        ToggleLoader(true);
        if (
          showEligibleMatchTarget === false &&
          showEligibleSingleTarget === false
        ) {
          if (!ValidateForm()) {
            setShowTopErrMsg(true);
            ToggleLoader(false);
            return false;
          }
        } else setIsAllDataFilled(true);

        setShowTopErrMsg(false);

        const additionalCohortData = cohortTreatmentS16
          .filter((item) => item.s16additionCohort === true) // Filter to include only items where s16additionCohort is true
          .map((item) => ({
            patientCohortTreatmentAdditionalPriorityId:
              item.PatientCohortTreatmentAdditionalPriorityId ?? 0,
            additionalCohortTreatmentId: item.cohortTreatmentID,
            cohortTreatmentID: item.cohortTreatmentID,
          }));

        const treatmentList = GetLocalStorageData("CohortTreatment");
        let cohortTreatment = JSON.parse(treatmentList);

        const roundModel = {
          centerTreatmentRoundList: chartSelectionList,
        };
        const AdditionalPriorityModel = {
          patientId: pid,
          CenterId: centerId,
          PatientEligibilityId: additionalPriority.patientEligibilityId,
          UserId: GetLoggedInUserID(),
          cohortTreatmentPriorityID: additionalPriority.s15cohortTreatment,
          noAdditionalCohortTreatmentPriorities:
            additionalPriority.s16NoCohortTreatment,
          cohortTreatmentAdditionalPriorityList: additionalCohortData,
          cohortTreatmentModelList: cohortTreatment,
          metInclusionCriteria: showEligibleMatchTarget === true ? false : true,
          unmatchedOneTreatmentId: additionalPriority.unmatchedOneTreatmentId,
          roundModel: roundModel,
          cohortTreatmentMatchedTargetList:
            additionalPriority.cohortTreatmentMatchedTargets[0],
        };

        setIsEligible(AdditionalPriorityModel.metInclusionCriteria);

        if (pid > 0) {
          let response =
            await EligibilityCriteriaService.SaveAdditionalCohortTreatment(
              AdditionalPriorityModel,
            );

          if (response.status !== HTTPResponse.OK) {
            if (response?.status === HTTPResponse.Unauthorized) {
              HandleSessionTimeout();
            } else {
              throw response.error;
            }
          } else {
            ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
            await LoadData();
            if (AdditionalPriorityModel.metInclusionCriteria) {
              navigatePaths.nextPage = "/Demographics";
            }
            //Set eligibilityCriteriaLocked property of patient object
            const ptArr = {
              ...patientData,
              eligibilityCriteriaLocked: response?.data ?? false,
            };
            AddLocalStorageData("patient", JSON.stringify(ptArr));
          }

          ToggleLoader(false);
        }
        return true;
      } catch (error) {
        ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
        ToggleLoader(false);
      }
    }
  };

  const renderStyledMessage = () => {
    return (
      <div>
        <span style={{ fontWeight: "normal" }}>
          {EligibilityCriteria_Msgs.EligibiltyLockConfirm}
        </span>
        <br />
        <div>
          <span style={{ fontWeight: "normal" }}>
            {EligibilityCriteria_Msgs.EligibiltyLockConfirm1}{" "}
          </span>
        </div>
      </div>
    );
  };

  const ValidateForm = () => {
    let isValid = true;
    if (additionalPriority.s15cohortTreatment === null) {
      setAdditionalPriority((prev) => ({
        ...prev,
        s15Empty: true,
      }));
      isValid = false;
    }
    const additionalCohortData = cohortTreatmentS16.filter(
      (item) => item.s16additionCohort === true,
    );

    if (
      (additionalPriority.s16NoCohortTreatment == null ||
        additionalPriority.s16NoCohortTreatment == 0) &&
      additionalCohortData.length == 0
    ) {
      setAdditionalPriority((prev) => ({
        ...prev,
        s16Empty: true,
      }));
      isValid = false;
    }

    setIsAllDataFilled(isValid);

    return isValid;
  };

  const sidebar = document.getElementById("mySidebar");
  const main = document.getElementById("main");

  const toggleNav = () => {
    if (isSideMenuActive === true) {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
      setIsSideMenuActive(false);
    } else if (isSideMenuActive === false) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
      setIsSideMenuActive(true);
    }
  };

  useEffect(() => {
    const sidebar = document.getElementById("mySidebar");
    const main = document.getElementById("main");

    if (isSideMenuActive === true) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
    } else {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
    }
  });
  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>
      <section className="main-survey-section">
        <div>
          <SideBarMenu
            activePageId={SideMenuItems.TransitionToChartAbstraction}
          />

          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              // onclick="toggleNav()"
              onClick={() => toggleNav()}
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>

          <div className="col-pad-left eligibiltylocked" id="main">
            <div className="survey-section-content">
              <div className="survey-section-content-header">
                <h4>TRANSITION TO CHART ABSTRACTION</h4>
              </div>
              {!showTopErrMsg &&
                pid != 0 &&
                additionalPriority.metInclusionCriteria != null &&
                (additionalPriority.metInclusionCriteria ? (
                  <div className="survey-section-content-message">
                    <p>{EligibilityCriteria_Msgs.EligiblePatient}</p>
                  </div>
                ) : additionalPriority.metInclusionCriteria == false ? (
                  <div className="clean-error">
                    <p>{EligibilityCriteria_Msgs.IneligiblePatient}</p>
                  </div>
                ) : (
                  <></>
                ))}

              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              <div
                className="survey-introduction-section"
                disabled={eligibilityDisabled}
              >
                <div className="survey-introduction-content">
                  <div>
                    {showEligibleMatchTarget === true && (
                      <div>
                        <p>
                          <b style={{ color: "red" }}>
                            The target number of new charts for{" "}
                            <span
                              dangerouslySetInnerHTML={{
                                __html: cohortTreatment,
                              }}
                              style={{
                                color: PageDesignConstants.fontColor,
                                fontWeight: "bolder",
                              }}
                            />{" "}
                            have been met. Please select another patient for
                            screening.
                          </b>
                          <br /> Click on next arrow to proceed with entering a
                          new patient chart.
                          <br />
                          <br />
                        </p>
                      </div>
                    )}

                    {showEligibleSingleTarget === true && (
                      <div>
                        <p>
                          You will now proceed to completing the chart
                          abstraction for this patient for{" "}
                          <span
                            dangerouslySetInnerHTML={{
                              __html: cohortTreatment,
                            }}
                            style={{
                              color: PageDesignConstants.fontColor,
                              fontWeight: "bolder",
                            }}
                          />
                          . As you review and abstract the patient's chart,
                          please remember the requirements on AE reporting
                          according to the Study Protocol, Section 5. See{" "}
                          <span style={{ color: "blue" }}>
                            {" "}
                            <u>
                              {" "}
                              <span
                                data-tooltip-id="encounterTip"
                                style={{ color: "blue" }}
                                onClick={() =>
                                  setShowHideHyperlinkModalAEReporting(true)
                                }
                              >
                                AE Reporting
                              </span>
                              {showHideHyperlinkModalAEReporting && (
                                <InfoPopUp
                                  description={hyperlinkTextAEReporting}
                                  OkClick={() =>
                                    setShowHideHyperlinkModalAEReporting(false)
                                  }
                                />
                              )}{" "}
                            </u>
                          </span>{" "}
                          for more information. <br /> Please click on Next
                          Arrow to proceed to the next section and complete data
                          extraction.
                          <br />
                          <br />
                        </p>
                      </div>
                    )}

                    {showEligibleTarget === true && (
                      <div>
                        <p>
                          This patient qualifies for chart data abstraction for
                          more than 1 treatment cohort. We would like to
                          abstract all eligible treatment cohorts for each
                          patient. From our records, the treatment cohorts
                          listed below in S15 and S16 have not yet met the
                          target for this round of data abstraction. If an
                          eligible cohort is not currently being displayed,
                          please notify{" "}
                          <u>
                            <a href="mailto:emmpower@analysisgroup.com">
                              emmpower@analysisgroup.com
                            </a>
                          </u>{" "}
                          to increase the target quota for that cohort as
                          appropriate.
                          <br />
                        </p>

                        <div className="survey-question-section">
                          <div className="survey-question-content">
                            <div className="question-answer">
                              <div className="question-bot-sapce">
                                <div className="question question-weight">
                                  <span>S15.</span>
                                  <span className="quest-text-pad">
                                    <span>
                                      We would like to prioritize cohorts that
                                      have the smallest number treated at your
                                      site. Which of the below treatment cohorts
                                      is least likely to meet the quota for this
                                      round of data collection?{" "}
                                      <b>
                                        We request that this treatment cohort be
                                        included as a required abstraction
                                        cohort, in addition to any others
                                        available.
                                      </b>{" "}
                                    </span>
                                  </span>
                                </div>
                                <div className=" double-dig-answer">
                                  {cohortTreatmentS15?.map((i, index) => {
                                    return (
                                      <div
                                        className="answer-list-text answer-pad-left"
                                        key={index}
                                      >
                                        <label>
                                          {" "}
                                          <input
                                            type="radio"
                                            id={i}
                                            key={`cohorttreatment-${i.cohortTreatmentID}`}
                                            value={i.cohortTreatmentID}
                                            name={"cohorttreatment-" + i}
                                            checked={
                                              selectedCohortTreatmentID ==
                                              i.cohortTreatmentID
                                            }
                                            onChange={HandleChange}
                                          />
                                          <span className="radio-text-padding">
                                            {i.cohortTreatmentName}
                                            {i.cohortTreatmentNameSuperscript ==
                                            null ? (
                                              ""
                                            ) : (
                                              <>
                                                <sup className="supscript">
                                                  {i.cohortTreatmentNameSuperscript.slice(
                                                    0,
                                                    2,
                                                  )}
                                                </sup>
                                                {i.cohortTreatmentNameSuperscript.slice(
                                                  2,
                                                )}
                                              </>
                                            )}
                                          </span>
                                        </label>
                                      </div>
                                    );
                                  })}
                                </div>
                                <ErrorField
                                  show={additionalPriority.s15Empty}
                                  message={EligibilityCriteria_Msgs.s15}
                                />
                              </div>

                              <br />
                              <div className="question-bot-sapce">
                                <div className="question question-weight">
                                  <span>S16.</span>
                                  <span className="quest-text-pad">
                                    <span>
                                      Select all additional treatment cohorts
                                      that will be abstracted for this patient.{" "}
                                      <u>
                                        Please only de-select a treatment cohort
                                        if you have been instructed to restrict
                                        specific cohorts during abstraction.
                                      </u>
                                    </span>
                                  </span>
                                </div>
                                <div className=" double-dig-answer">
                                  <div className="answer-list-text answer-pad-left">
                                    <label>
                                      <input
                                        type="radio"
                                        id="s16NoCohortTreatment"
                                        name="s16NoCohortTreatment"
                                        value={1}
                                        checked={
                                          additionalPriority.s16NoCohortTreatment ===
                                          1
                                        }
                                        onChange={HandleChangeNoTreatment}
                                      />
                                      <span className="radio-text-padding">
                                        No additional treatment cohorts are
                                        needed for abstraction{" "}
                                      </span>
                                    </label>
                                  </div>
                                  <div>
                                    {cohortTreatmentS16?.map(
                                      (childData, childIdx) => (
                                        <div
                                          className="answer-list-text answer-pad-left"
                                          key={childIdx}
                                        >
                                          <label>
                                            {" "}
                                            <input
                                              type="checkbox"
                                              key={childIdx}
                                              value={
                                                childData.cohortTreatmentID
                                              }
                                              name={
                                                "cohorttreatment-" + childIdx
                                              }
                                              checked={
                                                childData.s16additionCohort
                                              }
                                              onChange={HandleCheckboxChange}
                                            />
                                            <span className="radio-text-padding">
                                              {childData.cohortTreatmentName}
                                              {childData.cohortTreatmentNameSuperscript ==
                                              null ? (
                                                ""
                                              ) : (
                                                <>
                                                  <sup className="supscript">
                                                    {childData.cohortTreatmentNameSuperscript.slice(
                                                      0,
                                                      2,
                                                    )}
                                                  </sup>
                                                  {childData.cohortTreatmentNameSuperscript.slice(
                                                    2,
                                                  )}
                                                </>
                                              )}
                                            </span>
                                          </label>
                                        </div>
                                      ),
                                    )}
                                  </div>
                                </div>
                                <ErrorField
                                  show={additionalPriority.s16Empty}
                                  message={EligibilityCriteria_Msgs.s16}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="survey-question-section">
                          <div className="survey-question-content">
                            <p>
                              Based on the responses above, data will be
                              abstracted for{" "}
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: cohortTreatment,
                                }}
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              />
                              . You will now proceed to completing the chart
                              abstraction for this patient for{" "}
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: cohortTreatment,
                                }}
                                style={{
                                  color: PageDesignConstants.fontColor,
                                  fontWeight: "bolder",
                                }}
                              />
                              . As you review and abstract the patient's chart,
                              please remember the requirements on AE reporting
                              according to the Study Protocol, Section 5. See{" "}
                              <span
                                data-tooltip-id="encounterTip"
                                className="modal-popup"
                                onClick={() =>
                                  setShowHideHyperlinkModalAEReporting(true)
                                }
                              >
                                AE Reporting
                              </span>
                              {showHideHyperlinkModalAEReporting && (
                                <InfoPopUp
                                  description={hyperlinkTextAEReporting}
                                  OkClick={() =>
                                    setShowHideHyperlinkModalAEReporting(false)
                                  }
                                />
                              )}{" "}
                              for more information.{" "}
                            </p>
                            <br />
                            <p>
                              {" "}
                              Please click on the Next Arrow to proceed to the
                              next section and complete data extraction.
                            </p>
                            <br />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TransitionToChartAbstraction;
